import styles from '@/components/template/header/Header.module.scss'
import React, { useState, Fragment, useCallback, useEffect, useContext } from 'react'
import MainNavigation from '@default/components/template/navigations/MainNavigation'
import { Container, Navbar } from 'react-bootstrap'
import Link from 'next/link'
import tenantCmsObject from '@/entities/tenantCms/interface'
import HeaderLogo from '@/components/template/header/HeaderLogo'
import BreakingNewsAlert from '@/components/elements/BreakingNewsAlert'
import { AppConfigContext } from '@/app/providers/AppConfigProvider'

// eslint-disable-next-line react/display-name
const MemoMainNavigation = React.memo((Props) => {
  // @ts-ignore
  return <MainNavigation {...Props} />
})
// eslint-disable-next-line react/display-name
const MemoHeaderLog = React.memo(() => {
  // @ts-ignore
  return <HeaderLogo />
})

interface Props {
  cms: tenantCmsObject
}

const Header = ({ cms }: Props) => {
  // navbar color
  const colorTriggerDistance = 100
  const [colorChange, setColorChange] = useState(false)

  // Listener erst nach dem Mount registrieren und beim Unmount entfernen (frueher im Render:
  // bei jedem Render ein weiterer Listener, setState auf noch nicht gemountete Komponente)
  useEffect(() => {
    const changeNavbarColor = () => setColorChange(window.scrollY >= colorTriggerDistance)
    changeNavbarColor()
    window.addEventListener('scroll', changeNavbarColor, { passive: true })
    return () => {
      window.removeEventListener('scroll', changeNavbarColor)
    }
  }, [])

  // navbar visibility
  const visibilityTriggerDistance = 500
  const initialY = typeof window !== 'undefined' ? window.scrollY : 0
  const [visible, setVisible] = useState(true)
  const [y, setY] = useState(initialY)

  const handleNavbarVisibility = useCallback(
    (e: Event) => {
      const window: Window = e.currentTarget as unknown as Window
      if (y > window.scrollY) {
        setVisible(true)
      } else if (y < window.scrollY) {
        if (window.scrollY > visibilityTriggerDistance) {
          setVisible(false)
        }
      }
      setY(window.scrollY)
    },
    [y]
  )

  useEffect(() => {
    setY(window.scrollY)
    window.addEventListener('scroll', handleNavbarVisibility, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleNavbarVisibility)
    }
  }, [handleNavbarVisibility])

  // breaking news alert above the navbar, pkag only shows the notice in the booking wizard
  const appConfig = useContext(AppConfigContext)
  const showBreakingNews = appConfig.maintenance.onlineBookingUnavailable && process.env.NEXT_PUBLIC_THEME !== 'pkag'
  const [breakingNewsHeight, setBreakingNewsHeight] = useState(0)

  return (
    <>
      <Fragment>
        {showBreakingNews && <BreakingNewsAlert className={!visible ? 'hidden' : ''} onHeightChange={setBreakingNewsHeight} />}
        <Navbar
          collapseOnSelect
          expand="xl"
          fixed="top"
          style={showBreakingNews && visible ? { top: breakingNewsHeight } : undefined}
          className={`${styles.navbar} ${colorChange ? styles.bgWhite : ''} ${!visible ? styles.hidden : ''}`}
        >
          <Container fluid>
            <Navbar.Brand as={Link} href={'/'} prefetch={false} data-tr-click={'header:logo:click'}>
              <MemoHeaderLog />
            </Navbar.Brand>
            {/*@ts-ignore*/}
            <MemoMainNavigation categories={cms.categories} contactBlockSettings={cms.config.contactBlockSettings} />
          </Container>
        </Navbar>
      </Fragment>
    </>
  )
}

export default Header
